import { render, staticRenderFns } from "./Kbli.vue?vue&type=template&id=646344e8&scoped=true&"
import script from "./Kbli.vue?vue&type=script&lang=js&"
export * from "./Kbli.vue?vue&type=script&lang=js&"
import style0 from "./Kbli.vue?vue&type=style&index=0&id=646344e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646344e8",
  null
  
)

export default component.exports